import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAuthentication } from "../../store/slices/authSlice";

export default function ProtectedRoute({ children }) {
  const dispatch = useDispatch();
  const isAuthenticated = JSON.parse(localStorage.getItem("authenticated"));
  const token = JSON.parse(localStorage.getItem("token"));
  const user = JSON.parse(localStorage.getItem("user"));
  if (!isAuthenticated && !token) {
    return <Navigate to="/login" replace />;
  }
  dispatch(setAuthentication({ token, user }));
  return children ? children : <Outlet />;
}
